import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  return (
    <div className="bg-white rounded-xl p-8 shadow-lifted">
      <h1 className="font-display text-heading-lg text-center mb-2">Reset password</h1>
      <p className="text-center text-warm-gray mb-8">
        Enter your email and we'll send you a reset link
      </p>
      <form className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-navy mb-1">Email</label>
          <input type="email" className="input" placeholder="you@example.com" required />
        </div>
        <button type="submit" className="btn-primary w-full justify-center">
          Send reset link
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-warm-gray">
        <Link to="/login" className="text-sage font-medium hover:text-sage-dark">
          Back to sign in
        </Link>
      </p>
    </div>
  );
}
